import { render, staticRenderFns } from "./OrganizerListItem.vue?vue&type=template&id=cf2ef3a6&scoped=true"
import script from "./OrganizerListItem.vue?vue&type=script&lang=js"
export * from "./OrganizerListItem.vue?vue&type=script&lang=js"
import style0 from "./OrganizerListItem.vue?vue&type=style&index=0&id=cf2ef3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2ef3a6",
  null
  
)

export default component.exports